export default __webpack_public_path__ + "static/media/Saly-10.906f9682.svg";